import './Assets/async-content/index.js';
import './Assets/async-content/patchForCart.js';
import './Assets/dialog/index.js';
import './Assets/expand/index.js';
import './Assets/eco-label/index.js';
import './Assets/datalayer/index.js';
import './Assets/countdown/index.js';
import './Assets/track-attribute.js';
import registerServiceWorker from '@cloudnavfnac/service-worker-registration';
registerServiceWorker();
